var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text--secondary"},[_c('span',{staticClass:"dot"}),_vm._v(" обновлено "),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("unixtimeToCalendar")(_vm.updTimestamp)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }